import { render, staticRenderFns } from "./fotos.vue?vue&type=template&id=4d011527&"
import script from "./fotos.vue?vue&type=script&lang=js&"
export * from "./fotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports